import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import UpdateMyProfileSkeleton from '../../components/Skeletons/UpdateMyProfileSkeleton';
import { inputPhoneMasking } from '../../utils/validators';

const EditProfileModal = ({
  editProfileModal,
  handleModalClose,
  handleEditProfile,
  loading = false,
  data,
}) => {
  const { t } = useTranslation();
  const {
    userName,
    setUserName,
    userEmail,
    setUserEmail,
    userPhone,
    setUserPhone,
    userAddress,
    setUserAddress,
  } = data;

  return (
    <Modal show={editProfileModal}>
      <ModalHeading heading={t('screens.myProfile.editModal.heading', { defaultValue: 'Update your profile' })} />
      {loading ? (
        <UpdateMyProfileSkeleton />
      ) : (
        <ModalForm style={{ marginBottom: '2.5rem' }}>
          <InputsSection>
            <InputBox
              label={t('screens.myProfile.editModal.fullName', { defaultValue: 'Full Name' })}
              placeholder='eg, John Doe'
              value={userName.value}
              onChange={(event) => {
                setUserName({ value: event.target.value, error: '' });
              }}
              errorMessage={userName.error}
            />
            <InputBox
              label={t('screens.myProfile.editModal.email', { defaultValue: 'Email' })}
              placeholder='eg, johndoe@example.com'
              value={userEmail.value}
              onChange={(event) => {
                // setUserEmail({ value: event.target.value, error: '' });
              }}
              errorMessage={userEmail.error}
              disabled={true}
            />
          </InputsSection>

          <InputsSection>
            <InputBox
              label={t('screens.myProfile.editModal.phone', { defaultValue: 'Phone' })}
              placeholder='eg, 123-456-789'
              value={userPhone.value}
              onChange={(event) => {
                setUserPhone({ value: inputPhoneMasking(event.target.value), error: '' });
              }}
              errorMessage={userPhone.error}
            />
            <InputBox
              label={t('screens.myProfile.editModal.address', { defaultValue: 'Address' })}
              placeholder='eg, 692 SW. 53rd St. Irwin, PA 15642'
              value={userAddress.value}
              onChange={(event) => {
                setUserAddress({ value: event.target.value, error: '' });
              }}
              errorMessage={userAddress.error}
            />
          </InputsSection>

          <ModalButtons
            submitButtonLabel={t('common.save', { defaultValue: 'Save' })}
            onSubmit={handleEditProfile}
            cancelButtonLabel={t('common.cancel', { defaultValue: 'Cancel' })}
            onCancel={handleModalClose}
          />
        </ModalForm>
      )}
    </Modal>
  );
};

export default EditProfileModal;
